import { Inject, Injectable, OnDestroy, OnInit } from "@angular/core";
import { from, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import "rxjs/internal/operators";
import { filter, map, takeUntil } from "rxjs/operators";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { MSALInstanceFactory } from "../sign-in/msal-factory";
import { AppConstants } from "../app.constants";


@Injectable({
  providedIn: "root",
})
export class AuthService implements OnInit {
  private loginChangedSubject = new Subject<boolean>();
  loginChanged = this.loginChangedSubject.asObservable();
  public accountInfo: AuthenticationResult;
  private readonly _destroying$ = new Subject<void>();
  loginDisplay = false;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  public config = {
    auth: {
      clientId: environment.client_Id,
      authority:environment.authority,
          },
     cache: {
      cacheLocation: "sessionStorage",
    },
  };

 

  // getUserProfile() {
  //   var headers = new Headers();

  //   headers.append("Authorization", this.getAccessToken());

  //   var options = {
  //     method: "GET",
  //     headers: headers,
  //   };

  //   var graphConfig = {
  //     graphEndPoint: environment.graphEndPoint, // "https://graph.microsoft.com/v1.0/me",
  //   };
  //   fetch(graphConfig.graphEndPoint, options).then(function (response) {
  //     //do something with response

  //     if (response.status == 200) {
  //       var data = response.json();
  //       data.then(function (userinfo) {
  //         var printResponse = JSON.stringify(userinfo);
  //       });
  //     }
  //   });
  // }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  ngOnInit(): void {}
  getBadgeNumber() {
    const claim = this.getClaims();
    return claim[environment.claimUrl]; // "http://schemas.cat.com/identity/claims/catloginid"];
  }

  get authenticated(): boolean {
    return this.msalService.instance.getActiveAccount() ? true : false;
  }

  getUserName() {
    const claim = this.getClaims();
    if (claim != null) {
      return claim.name;
    }

    return "";
  }

  async logIn() {
    await this.msalService.instance.loginRedirect({
      scopes:  [environment.scopesUserRead,environment.scopesOpenid,environment.scopesProfile],
      redirectUri: environment.redirectUrl, // "https://localhost:4200/response-oidc",
    });
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  getAccessToken() {
    var requestPermissionScope = {
      scopes: [environment.scopesUserRead],
    };
    var myMSALObj = MSALInstanceFactory();
    myMSALObj.acquireTokenSilent(requestPermissionScope).then((result) => {
      if (result != undefined) {
        return result.accessToken;
      }
    });
    return null;
  }

  getClaims(): any {
    const profile = this.msalService.instance.getActiveAccount().idTokenClaims;
    return profile != null ? profile : "";
  }

  completeLogin(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  completeLogout() {
    const selectedTheme = this.getSavedThemeOrDefault();
    this.clearStoragePreservingTheme(selectedTheme);

    this.msalService.logout();
    this.loginChangedSubject.next(true);
    document.cookie =
      "SSOCookie" +
      "=; Path=/; Domain=.cat.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      "CwsHttpModule2" + "=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    //window.location.replace("../");
    window.location.href = environment.CwsLogoutUrl;
  }

  private clearStoragePreservingTheme(selectedTheme: string): void {
    try {
      sessionStorage.clear();

      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key !== AppConstants.themeStorageKey) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach((key) => localStorage.removeItem(key));
      localStorage.setItem(AppConstants.themeStorageKey, selectedTheme);
    } catch {
      // Ignore storage errors; UI falls back to default theme safely.
    }
  }

  private getSavedThemeOrDefault(): string {
    try {
      const selectedTheme = localStorage.getItem(AppConstants.themeStorageKey);
      if (selectedTheme === AppConstants.lightTheme || selectedTheme === AppConstants.darkTheme) {
        return selectedTheme;
      }
    } catch {
      // Ignore storage errors and use default.
    }

    return AppConstants.defaultTheme;
  }
}

